import script from "./ReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportList.vue?vue&type=script&setup=true&lang=js"

import "./ReportList.vue?vue&type=style&index=0&id=32c94369&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c94369"]])

export default __exports__